import { render, staticRenderFns } from "./calItem.vue?vue&type=template&id=606c2167&scoped=true&"
import script from "./calItem.vue?vue&type=script&lang=ts&"
export * from "./calItem.vue?vue&type=script&lang=ts&"
import style0 from "./calItem.vue?vue&type=style&index=0&id=606c2167&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606c2167",
  null
  
)

component.options.__file = "calItem.vue"
export default component.exports